<template>
  <div id="app">
    
    <keep-alive :max="15" exclude="">
      <router-view/>
    </keep-alive>
    
  </div>
</template>

<script>
import {getUser_info} from './utils/api'
import {wx_fun} from './utils/vxshare'
  export default {
    name: 'App',
    data(){
      return{}
    },
    
    created() {
      console.log('APP created');
      
    },
    mounted() {
      const token = JSON.parse(localStorage.getItem('token')) || ''
      const code = this.$route.query.code
      // const path = this.$router.history.current.path
      const is_info = sessionStorage.getItem('is_info')

      console.log(!token);
      setTimeout(() => {
        if (!token && !code) {

          this.$router.replace('/login')
        }
        //只check token会出现绑定账号问题  --判断是否绑定账号接口
        else if(token && !is_info) {
          getUser_info(token)
          .then(res => {
            console.log(is_info);
            sessionStorage.setItem('user_info',JSON.stringify(res.data))
          })
        }

      }, 100);


      
      //   // if (Date.now() > token.expire) {
      //   //  // 本地无法跳转
      //   //   getLogin_url({back_url:"http://wx.library.bnuzh.edu.cn/login"})
      //   //   .then(res => {
      //   //       console.log(res)
      //   //       window.location.assign(res.data.url)
      //   //   });
      //   //   this.$message({
      //   //       message: '账号已过期！',
      //   //       type: 'error',
      //   //   });
      //   // } else {
      //   //   this.$message({
      //   //       message: '登录成功！',
      //   //       type: 'success',
      //   //   });
      //   // }
      //   // getUser_info(token)
      //   // .then(res => {
      //   //     console.log(res);
      //   // })
      // console.log('beforeMount');

      let ua = navigator.userAgent.toLowerCase();
      let isWeixin = ua.indexOf('micromessenger') !== -1;
      if (!isWeixin) {
        alert('请使用微信浏览器,否则将无法使用！')
      }
    },
    beforeMount(){
      wx_fun()
      
    },
    
  }
</script>

<style>
@import url("./assets/css/base.css");
@import url("./assets/css/wow.css");
@import url("./assets/css/element.css");
/* html {

} */
</style>


// WEBPACK FOOTER //
// src/App.vue